import * as React from "react";
import { SVGProps } from "react";

const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={props.width || "20"}
    height={props.height || "20"}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18.8977 1H1.85227C1.38159 1 1 1.38159 1 1.85227V18.898C1 19.3686 1.38159 19.7502 1.85227 19.7502H11.5114C11.982 19.7502 12.3636 19.3686 12.3636 18.898C12.3636 18.4273 11.982 18.0457 11.5114 18.0457H2.70455V10.6593H6.68182V13.7841C6.68182 14.2548 7.06341 14.6364 7.53409 14.6364C8.00477 14.6364 8.38636 14.2548 8.38636 13.7841V5.82955C8.38636 5.35886 8.00477 4.97727 7.53409 4.97727C7.06341 4.97727 6.68182 5.35886 6.68182 5.82955V8.95477H2.70455V2.70455H11.2273V6.96614C11.2273 7.43682 11.6089 7.81841 12.0795 7.81841H16.0568C16.5275 7.81841 16.9091 7.43682 16.9091 6.96614C16.9091 6.49545 16.5275 6.11386 16.0568 6.11386H12.9318V2.70455H18.0455V12.932H12.0795C11.6089 12.932 11.2273 13.3136 11.2273 13.7843C11.2273 14.255 11.6089 14.6366 12.0795 14.6366H18.0455V18.0457H16.625C16.1543 18.0457 15.7727 18.4273 15.7727 18.898C15.7727 19.3686 16.1543 19.7502 16.625 19.7502H18.8977C19.3684 19.7502 19.75 19.3686 19.75 18.898V1.85227C19.75 1.38159 19.3684 1 18.8977 1Z"
      fill={props.fill || "#4D5F7A"}
    />
  </svg>
);

export default SvgComponent;
